import type { PropsWithChildren } from 'react'
import { cn } from '@/src/utils/styles'
import { Button } from '../button'
import { ListRowButton, type ListRowButtonProps } from '../list-row'

export function BottomSheetListTitle({
  children,
  className,
  ...props
}: PropsWithChildren<
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >
>) {
  return (
    <span className={cn('text-secondary text-sm px-5', className)} {...props}>
      {children}
    </span>
  )
}

export function BottomSheetListContent({ children }: PropsWithChildren) {
  return (
    <div className='relative flex-shrink min-h-0 flex flex-col'>
      <div className='overflow-y-auto'>
        <div className='flex flex-col gap-6 px-5 pt-3 pb-7'>{children}</div>
      </div>
      <div className='absolute bottom-0 inset-x-0 h-4 bg-gradient-to-t from-surface2-100 from-30% to-transparent' />
    </div>
  )
}

export function BottomSheetListItem({
  children,
  ...props
}: PropsWithChildren<Omit<ListRowButtonProps, 'size' | 'variant'>>) {
  return (
    <ListRowButton variant={'ghost'} {...props}>
      {children}
    </ListRowButton>
  )
}

interface BottomSheetListFooterProps {
  setIsOpen?: (isOpen: boolean) => void
}
export function BottomSheetListFooter({
  children,
  setIsOpen,
}: PropsWithChildren<BottomSheetListFooterProps>) {
  return (
    <div className='pb-2 px-5'>
      {children}
      {setIsOpen && (
        <Button
          type='button'
          size='md'
          variant='secondary'
          className='w-full'
          onClick={() => setIsOpen(false)}
        >
          Close
        </Button>
      )}
    </div>
  )
}
